import React from 'react';
import styled from 'styled-components';
import {Colors, FontStyles} from "../constants";

export const Flex = styled.div`
    display: ${props => !!props.hide ? 'none' : 'flex'};
    flex-direction: ${(props) => 
        !!props.column ? 
            !!props.reverse ? 'column-reverse' : 'column' : 
            !!props.reverse ? 'row-reverse' : 'row'
    };
    flex-wrap: ${(props) => !!props.wrap ? 'wrap' : 'nowrap' };
    justify-content: ${(props) => !!props.column ? props.vAlign : props.hAlign};
    align-items: ${(props) => !!props.column ? props.hAlign : props.vAlign};
    ${(props) => !!props.wmax ? 'width: 100%;' : null}
    ${(props) => !!props.hmax ? 'height: 100%;' : null}
`;



